module.exports = __webpack_public_path__ + "img/feature_tt.1e81a9a9.gif";